import { render, staticRenderFns } from "./IdentificationsList.vue?vue&type=template&id=0bfdc5ce"
import script from "./IdentificationsList.vue?vue&type=script&lang=js"
export * from "./IdentificationsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports